import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FileUpload from '../../molecules/FileUpload';
import Intro from '../Intro';
import Button from '../../atoms/Button';
import './ManageHomepage.css';

class ManageHomepage extends Component {

  render() {

    const {homepage, homepageEdit, saving, loading, uploadingImage, cancelEditHomepage} = this.props;

    const editHomepage = () => {
      this.props.editHomepage(homepage);
    };

    const saveHomepage = () => {
      this.props.saveHomepage(homepageEdit);
    };

    const updateHomepageImage = (file) => {
      this.props.uploadHomepageImage(file.getFile()).then(val => {
        this.props.updateHomepage({
          homepageImage: val,
        });
      });
    };

    const updateHomepage = (ev) => {
      this.props.updateHomepage({
        [ev.target.name]: ev.target.value
      });
    };

    if ( saving ) {
      return (
        <div>Saving...</div>
      );
    } else if ( loading ) {
      return (
        <div>Loading...</div>
      );
    }

    return (
      <div className="ManageHomepage">
        {homepageEdit ? (
          <div>

            {uploadingImage && (
              <p> Uploading image ... </p>
            )}

            <div className="ManageHomepage-title">
              <label>Title:</label>
              <input type="text" name="title" value={homepageEdit.title || ''} onChange={updateHomepage} />
            </div>

            <div className="ManageHomepage-image">
              <label>Image:</label>
              <FileUpload name="homepageImage" type="img" value={homepageEdit.homepageImage} onChange={updateHomepageImage} />
            </div>

            <div className="ManageHomepage-blurb">
              <label>Blurb:</label>
              <textarea name="homepageText" value={homepageEdit.homepageText || ''} onChange={updateHomepage} rows={5} ></textarea>
            </div>

            <div className="controls">
              <Button onClick={saveHomepage} disabled={uploadingImage}> Save </Button>
              <Button onClick={cancelEditHomepage}> Cancel </Button>
            </div>

          </div>
        ) : (
          <div>
            <Intro />
            <div className="controls">
              <Button onClick={editHomepage} disabled={uploadingImage}>Edit Homepage</Button>
            </div>
          </div>
        )}
      </div>
    );

  }

}

ManageHomepage.propTypes = {
  homepage: PropTypes.object,
  homepageEdit: PropTypes.object,
  saving: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  uploadingImage: PropTypes.bool.isRequired,
  editHomepage: PropTypes.func.isRequired,
  cancelEditHomepage: PropTypes.func.isRequired,
  updateHomepage: PropTypes.func.isRequired,
  uploadHomepageImage: PropTypes.func.isRequired,
  saveHomepage: PropTypes.func.isRequired,
}

export default ManageHomepage;



// WEBPACK FOOTER //
// ./src/component/organisms/ManageHomepage/component.js